import * as Vue from 'vue'
import VueGoogleMaps from '@fawmi/vue-google-maps'
import Vuex from 'vuex';
import store from './store'; // data del Vuex
import Trend from 'vue3trend';

const App = {
    mounted() {
        console.log('Vue APP mounted');
    }
}

const app = Vue.createApp(App);

app.component("gmap-component", require('./components/GMapComponent.vue').default);
app.component("elements-component", require('./components/ElementsComponent.vue').default);
app.component("element_key-component", require('./components/ElementKeysComponent.vue').default); //TODO: fix plural
app.component("element_measures_table-component", require('./components/ElementMeasuresTableComponent.vue').default);
app.component("element_key_measures_table-component", require('./components/ElementKeyMeasuresTableComponent.vue').default);
app.component("element_key_measures_table_preview-component", require('./components/ElementKeyMeasuresTablePreviewComponent.vue').default);
//app.component("element_key_measures_table_in_elements_index-component", require('./components/ElementKeyMeasuresTableInElementsIndexComponent.vue').default);
app.component("trendchart-component", require('./components/TrendChartComponent').default);
app.component("element_measures_logger-component", require('./components/ElementMeasuresLoggerComponent.vue').default);

app.use(VueGoogleMaps, {
    load: {
        key: process.env.MIX_GMAP_KEY,
        language: 'es'
    },
});
app.use(new Vuex.Store(store));
app.use(Trend);

app.mount("#app");
